import React from 'react'
import HintPopover from "../../../core/gd-ui/hint-popover/hint-popover"

type Props = {
    name                : string
    icon                : string

    upgradeRequired?    : any // UPGRADE_PRO | UPGRADE_BUSINESS | false


    // urls of the items inside: landing on one of them opens the branch, so a
    // selected child is never hidden behind a collapsed parent
    // example: i'm in webhook -> logs when refresh I want webhook section in main meny to be open (!)
    expandForUrls?      : string[]

    dndPreview?         : boolean
    dndIsDragged?       : boolean

    style?              : any
    children?           : any

    controls?           : any   // rendered on the right of the row (i.e. add button shown on hover)

    onClick?            : {(e:any):void}
}

export default class NavigationMenuItemFoldable extends React.Component<Props,any> {

    constructor(props:Props) {
        super(props)

        this.state = {
            isExpanded: this.holdsCurrentUrl()
        }
    }

    componentDidMount() {
        gd.router.on('route', this.onRoute)
    }

    componentWillUnmount() {
        gd.router.off('route', this.onRoute)
    }

    // only ever opens: collapsing again on every navigation would fight the user
    onRoute = () => {
        if (!this.state.isExpanded && this.holdsCurrentUrl()) this.setState({isExpanded: true})
    }

    holdsCurrentUrl(): boolean {
        const fragment = gd.router.history.fragment || ''

        return _.some(this.props.expandForUrls, (url:string) => fragment.includes(url))
    }

    onClick = (e:any) => {
        e.stopPropagation()

        if (this.props.upgradeRequired) {
            gd.modals.other.upgrade(this.props.upgradeRequired)
        } else {
            this.setState({
                isExpanded: !this.state.isExpanded
            })
        }
    }

    render() {
        const classes = Classes('item is-foldable',{
            'dnd-preview'   : this.props.dndPreview,
            'dnd-is-dragged': this.props.dndIsDragged,
        })

        const arrowClasses = Classes("arrow", {
            "closed"    : !this.state.isExpanded,
            "open"      : this.state.isExpanded,
        })


        // style is required for ReorderList (pointer-events: none)
        return (
            <React.Fragment>
                <div className={classes} style={this.props.style} onClick={this.onClick}>
                    <div className="row">
                        <div className={arrowClasses}/>
                        <div className={Classes('icon', this.props.icon)}/>
                        <div className="name">{this.props.name}</div>

                        {this.props.controls}
                    </div>

                    {this.state.useHint && <HintPopover parent={this} hint={this.props.name} multiline={true}/>}
                </div>

                {this.state.isExpanded && this.props.children}
            </React.Fragment>
        )
    }

}

